/**
 * Aria — asistente de Airosa
 * Widget de chat para el tema de Shopify. No contiene claves.
 * Posición: esquina inferior izquierda.
 * Ofrece la opción "Asesor personal de regalos" y, si el cliente la elige, lo lleva a la página del asesor.
 */
(function () {
  /* ── Configuración ─────────────────────────────────────── */
  var ENDPOINT = "https://aria-airosa.leninbayona5.workers.dev";
  var WHATSAPP = "https://wa.me/51932914677";
  var ASESOR_URL = "/pages/conserje-de-regalos";
  var ICONO = "https://cdn.shopify.com/s/files/1/0727/9237/5578/files/AIROSA-ICON.png?v=1784782478";

  var INK = "#1C1C1C", GOLD = "#FFAB40", CREAM = "#F6F1E8";

  var SALUDO = "Bienvenido a Airosa. Puedo orientarte sobre nuestras piezas, precios y envíos, o llevarte con nuestro asesor personal de regalos.";
  var INVITACION = "¿Te ayudo a elegir?";
  var SUGERIDAS = ["¿Cuánto duran las rosas?", "Delivery hoy", "Precios"];
  var ESPERA_INVITA = 4000;
  var DURACION_INVITA = 10000;
  var TIMEOUT = 25000;
  var PIDE_ASESOR = /asesor|conserje|qué regalo|que regalo|regalo.{0,25}(recomiend|recomend|elegir|ayud|sugier|idea)|(recomiend|recomend|ayud|sugier|idea).{0,25}regalo/i;

  /* ── Estado ────────────────────────────────────────────── */
  var abierto = false, cargando = false, historial = [], ultimo = -1;
  try { var g = sessionStorage.getItem("aria_chat"); if (g) historial = JSON.parse(g); } catch (e) {}
  function guardar() { try { sessionStorage.setItem("aria_chat", JSON.stringify(historial.slice(-20))); } catch (e) {} }

  /* ── Estilos ───────────────────────────────────────────── */
  var css = document.createElement("style");
  css.textContent = [
    "@import url('https://fonts.googleapis.com/css2?family=Jost:wght@300;400&family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300&display=swap');",

    /* Velo (solo móvil) */
    "#aria-velo{position:fixed;inset:0;z-index:2147482999;background:rgba(15,13,10,.6);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);opacity:0;pointer-events:none;transition:opacity .45s ease}",
    "#aria-velo.on{opacity:1;pointer-events:auto}",

    /* Botón */
    "#aria-fab{position:fixed;left:20px;bottom:24px;z-index:2147483000;width:58px;height:58px;border-radius:50%;background:" + INK + ";border:1px solid rgba(255,171,64,.55);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;box-shadow:0 10px 34px rgba(0,0,0,.4);transition:border-color .45s,transform .45s cubic-bezier(.2,.7,.3,1)}",
    "#aria-fab:hover{border-color:" + GOLD + ";transform:translateY(-2px)}",
    "#aria-fab:focus-visible{outline:2px solid " + GOLD + ";outline-offset:3px}",
    "#aria-fab img{width:34px;height:34px;object-fit:contain;display:block}",

    /* Etiqueta de invitación */
    "#aria-invita{position:fixed;left:88px;bottom:36px;z-index:2147483000;background:" + INK + ";border:1px solid rgba(255,171,64,.22);color:" + CREAM + ";font-family:Jost,sans-serif;font-size:10px;font-weight:300;letter-spacing:.2em;text-transform:uppercase;padding:11px 16px;cursor:pointer;white-space:nowrap;box-shadow:0 8px 26px rgba(0,0,0,.32);opacity:0;transform:translateX(-10px);pointer-events:none;transition:opacity .7s ease,transform .7s cubic-bezier(.2,.7,.3,1)}",
    "#aria-invita.on{opacity:1;transform:translateX(0);pointer-events:auto}",
    "#aria-invita:hover{border-color:rgba(255,171,64,.6)}",

    /* Panel */
    "#aria-panel{position:fixed;left:20px;bottom:96px;z-index:2147483001;width:376px;max-width:calc(100vw - 40px);height:480px;max-height:calc(100vh - 180px);background:" + INK + ";border:1px solid rgba(255,171,64,.16);box-shadow:0 40px 90px rgba(0,0,0,.5);display:none;flex-direction:column;font-family:Jost,system-ui,sans-serif;overflow:hidden;opacity:0;transform:translateY(14px);transition:opacity .45s ease,transform .45s cubic-bezier(.2,.7,.3,1)}",
    "#aria-panel.abierto{display:flex}",
    "#aria-panel.visible{opacity:1;transform:translateY(0)}",

    /* Cabecera */
    "#aria-head{padding:26px 26px 18px;flex-shrink:0;position:relative}",
    ".aria-eyebrow{font-size:9px;font-weight:400;letter-spacing:.4em;text-transform:uppercase;color:rgba(255,171,64,.7)}",
    ".aria-name{font-family:'Cormorant Garamond',serif;font-weight:300;font-size:34px;letter-spacing:.02em;line-height:1;margin:10px 0 14px;color:" + CREAM + "}",
    "#aria-close{position:absolute;top:22px;right:22px;background:none;border:none;font-size:14px;color:rgba(246,241,232,.35);cursor:pointer;padding:6px;transition:color .35s}",
    "#aria-close:hover{color:" + CREAM + "}",
    "#aria-close:focus-visible{outline:1px solid " + GOLD + ";outline-offset:2px}",

    /* Conversación */
    "#aria-log{flex:0 1 auto;min-height:0;overflow-y:auto;padding:0 26px 10px;scrollbar-width:thin;scrollbar-color:rgba(255,171,64,.25) transparent}",
    "#aria-log::-webkit-scrollbar{width:2px}",
    "#aria-log::-webkit-scrollbar-thumb{background:rgba(255,171,64,.25)}",
    ".aria-turn{padding:18px 0;border-top:1px solid rgba(246,241,232,.06)}",
    ".aria-turn:first-child{border-top:none;padding-top:4px}",
    ".aria-who{font-size:8px;font-weight:400;letter-spacing:.38em;text-transform:uppercase;margin-bottom:9px;display:block}",
    ".aria-turn.a .aria-who{color:rgba(255,171,64,.65)}",
    ".aria-turn.u .aria-who{color:rgba(246,241,232,.28)}",
    ".aria-link{display:inline-block;margin-top:8px;font-family:Jost,sans-serif;font-size:10px;font-weight:400;letter-spacing:.24em;text-transform:uppercase;color:" + GOLD + ";text-decoration:none;border-bottom:1px solid rgba(255,171,64,.4);padding-bottom:3px;transition:border-color .3s}",
    ".aria-link:hover{border-bottom-color:" + GOLD + "}",
    ".aria-turn.a .aria-text{font-family:'Cormorant Garamond',serif;font-weight:300;font-size:19px;line-height:1.65;color:" + CREAM + ";white-space:pre-wrap}",
    ".aria-turn.u{text-align:right}",
    ".aria-turn.u .aria-text{font-family:Jost,sans-serif;font-size:12.5px;font-weight:300;letter-spacing:.04em;line-height:1.6;color:rgba(246,241,232,.5);white-space:pre-wrap}",
    ".aria-turn.nueva{opacity:0;transform:translateY(6px);animation:ariaTinta 1s ease forwards}",
    "@keyframes ariaTinta{to{opacity:1;transform:translateY(0)}}",

    /* Sugerencias */
    "#aria-chips{display:flex;flex-wrap:wrap;gap:8px;padding:16px 26px 6px;flex-shrink:0}",
    ".aria-chip{font-family:Jost,sans-serif;font-size:10px;font-weight:300;letter-spacing:.18em;text-transform:uppercase;padding:8px 14px;border:1px solid rgba(255,171,64,.25);background:none;color:rgba(255,171,64,.8);cursor:pointer;transition:all .35s}",
    ".aria-chip:hover{background:rgba(255,171,64,.08);border-color:rgba(255,171,64,.55);color:" + GOLD + "}",
    ".aria-chip-main{background:" + GOLD + ";border-color:" + GOLD + ";color:" + INK + ";font-weight:400;letter-spacing:.2em}",
    ".aria-chip-main:hover{background:#ffbe6b;border-color:#ffbe6b;color:" + INK + "}",

    /* Entrada */
    "#aria-foot{display:flex;align-items:center;margin-top:auto;border-top:1px solid rgba(246,241,232,.08);flex-shrink:0;padding:0 26px;transition:border-color .4s}",
    "#aria-foot:focus-within{border-top-color:rgba(255,171,64,.4)}",
    "#aria-input{flex:1;border:none;outline:none;padding:19px 0;font-family:Jost,sans-serif;font-weight:300;font-size:15px;letter-spacing:.02em;background:transparent;color:" + CREAM + "}",
    "#aria-input::placeholder{color:rgba(246,241,232,.25);letter-spacing:.04em}",
    "#aria-send{border:none;background:none;color:" + GOLD + ";font-family:Jost,sans-serif;font-size:9px;letter-spacing:.3em;text-transform:uppercase;cursor:pointer;padding:10px 0 10px 18px;transition:opacity .35s,letter-spacing .35s}",
    "#aria-send:hover:not(:disabled){letter-spacing:.36em}",
    "#aria-send:disabled{opacity:.22;cursor:default}",

    /* Vía humana */
    "#aria-humano{display:block;text-align:center;padding:13px;font-size:9px;letter-spacing:.26em;text-transform:uppercase;color:rgba(246,241,232,.3);text-decoration:none;border-top:1px solid rgba(246,241,232,.05);flex-shrink:0;transition:color .35s}",
    "#aria-humano:hover{color:rgba(255,171,64,.8)}",

    /* Onda de espera */
    ".aria-wave path{stroke:" + GOLD + ";stroke-width:1;fill:none}",
    ".aria-pensando .aria-wave path{stroke-dasharray:14 8;animation:ariaFluir 2s linear infinite}",
    "@keyframes ariaFluir{to{stroke-dashoffset:-44}}",

    /* Móvil */
    "@media (max-width:520px){",
      "#aria-panel{left:12px;right:12px;width:auto;bottom:14px;top:64px;height:auto;max-height:none}",
      "#aria-fab{bottom:20px;left:16px;width:54px;height:54px}",
      "#aria-fab img{width:31px;height:31px}",
      "#aria-invita{left:80px;bottom:32px;font-size:9px;letter-spacing:.16em;padding:10px 14px}",
      ".aria-turn.a .aria-text{font-size:20px}",
    "}",

    "@media (prefers-reduced-motion:reduce){#aria-panel,.aria-turn.nueva{transition:none;animation:none;opacity:1;transform:none}.aria-pensando .aria-wave path{animation:none}}"
  ].join("");
  document.head.appendChild(css);

  /* ── Elementos ─────────────────────────────────────────── */
  var ONDA = 'M0 4 q7 -4 14 0 t14 0 t14 0 t14 0 t14 0 t14 0 t14 0 t14 0 t14 0 t14 0';
  function ondaSVG(w) {
    return '<svg class="aria-wave" width="' + w + '" height="8" viewBox="0 0 140 8" preserveAspectRatio="none"><path d="' + ONDA + '"/></svg>';
  }

  var velo = document.createElement("div");
  velo.id = "aria-velo";
  document.body.appendChild(velo);

  var fab = document.createElement("button");
  fab.id = "aria-fab";
  fab.type = "button";
  fab.setAttribute("aria-label", "Abrir el asistente de Airosa");
  fab.innerHTML = '<img src="' + ICONO + '" alt="">';
  document.body.appendChild(fab);

  var invita = document.createElement("button");
  invita.id = "aria-invita";
  invita.type = "button";
  invita.textContent = INVITACION;
  document.body.appendChild(invita);

  var panel = document.createElement("div");
  panel.id = "aria-panel";
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-label", "Asistente de Airosa");
  panel.innerHTML =
    '<div id="aria-head">' +
      '<div class="aria-eyebrow">Airosa · Asistente</div>' +
      '<div class="aria-name">Aria</div>' + ondaSVG(140) +
      '<button id="aria-close" type="button" aria-label="Cerrar">&#10005;</button>' +
    '</div>' +
    '<div id="aria-log" aria-live="polite"></div>' +
    '<div id="aria-chips"></div>' +
    '<div id="aria-foot">' +
      '<input id="aria-input" placeholder="Escribe tu consulta" autocomplete="off" aria-label="Tu consulta">' +
      '<button id="aria-send" type="button">Enviar</button>' +
    '</div>' +
    '<a id="aria-humano" href="' + WHATSAPP + '" target="_blank" rel="noopener">Prefiero hablar con el equipo</a>';
  document.body.appendChild(panel);

  var log = panel.querySelector("#aria-log");
  var chips = panel.querySelector("#aria-chips");
  var input = panel.querySelector("#aria-input");
  var send = panel.querySelector("#aria-send");

  /* ── Invitación ────────────────────────────────────────── */
  var vista = false;
  try { vista = sessionStorage.getItem("aria_invita") === "1"; } catch (e) {}

  function ocultarInvita() {
    invita.classList.remove("on");
    try { sessionStorage.setItem("aria_invita", "1"); } catch (e) {}
  }

  if (!vista && !historial.length) {
    setTimeout(function () { if (!abierto) invita.classList.add("on"); }, ESPERA_INVITA);
    setTimeout(ocultarInvita, ESPERA_INVITA + DURACION_INVITA);
  }
  invita.onclick = function () { ocultarInvita(); abrir(); };

  /* ── Render ────────────────────────────────────────────── */
  function enlace(url, etiqueta, mismaPestana) {
    var a = document.createElement("a");
    a.href = url;
    if (!mismaPestana) { a.target = "_blank"; a.rel = "noopener noreferrer"; }
    a.className = "aria-link";
    a.textContent = etiqueta;
    return a;
  }
  function conEnlaces(texto) {
    var frag = document.createDocumentFragment();
    var re = /https?:\/\/[^\s<>"')]+/g;
    var i = 0, m, hayWa = false;
    while ((m = re.exec(texto)) !== null) {
      if (m.index > i) frag.appendChild(document.createTextNode(texto.slice(i, m.index)));
      var url = m[0].replace(/[.,;:!?]+$/, "");
      var esWa = /wa\.me|whatsapp\.com/i.test(url);
      if (esWa) hayWa = true;
      frag.appendChild(enlace(url, esWa ? "Escribir por WhatsApp" : "Ver la pieza"));
      i = m.index + url.length;
    }
    if (i < texto.length) frag.appendChild(document.createTextNode(texto.slice(i)));
    /* Si la respuesta habla de WhatsApp y no trae enlace, se agrega el de Airosa */
    if (!hayWa && /whats\s?app|wsp\b|wasap/i.test(texto)) {
      frag.appendChild(document.createElement("br"));
      frag.appendChild(enlace(WHATSAPP, "Escribir por WhatsApp"));
    }
    return frag;
  }
  function pintar() {
    log.innerHTML = "";
    historial.forEach(function (m, i) {
      var t = document.createElement("div");
      t.className = "aria-turn " + (m.role === "user" ? "u" : "a") + (i > ultimo ? " nueva" : "");
      var w = document.createElement("span");
      w.className = "aria-who";
      w.textContent = m.role === "user" ? "Tú" : "Aria";
      var p = document.createElement("div");
      p.className = "aria-text";
      if (m.role === "user") {
        p.textContent = m.content;
      } else {
        p.appendChild(conEnlaces(m.content));
      }
      t.appendChild(w); t.appendChild(p);
      if (m.asesor) t.appendChild(enlace(ASESOR_URL, "Abrir asesor personal de regalos", true));
      log.appendChild(t);
    });
    ultimo = historial.length - 1;
    if (cargando) {
      var d = document.createElement("div");
      d.className = "aria-turn a aria-pensando";
      d.innerHTML = '<span class="aria-who">Aria</span>' + ondaSVG(90);
      log.appendChild(d);
    }
    log.scrollTop = log.scrollHeight;
    chips.style.display = historial.length > 1 ? "none" : "flex";
  }

  /* Opción destacada: lleva a la página del asesor */
  function irAlAsesor() {
    historial.push({ role: "user", content: "Asesor personal de regalos" });
    historial.push({ role: "assistant", content: "Con gusto. Te llevo con nuestro asesor personal de regalos.", asesor: true });
    guardar();
    pintar();
    setTimeout(function () { location.href = ASESOR_URL; }, 900);
  }

  var cAsesor = document.createElement("button");
  cAsesor.type = "button";
  cAsesor.className = "aria-chip aria-chip-main";
  cAsesor.textContent = "Asesor personal de regalos";
  cAsesor.onclick = irAlAsesor;
  chips.appendChild(cAsesor);

  SUGERIDAS.forEach(function (s) {
    var c = document.createElement("button");
    c.type = "button";
    c.className = "aria-chip";
    c.textContent = s;
    c.onclick = function () { enviar(s); };
    chips.appendChild(c);
  });

  /* ── Envío ─────────────────────────────────────────────── */
  function enviar(texto) {
    var q = (texto || input.value).trim();
    if (!q || cargando) return;
    historial.push({ role: "user", content: q });
    input.value = "";

    /* Si el cliente pide ayuda para elegir un regalo, se le ofrece el asesor */
    if (PIDE_ASESOR.test(q)) {
      historial.push({ role: "assistant", content: "Para eso contamos con un asesor personal de regalos: en tres preguntas te recomienda las piezas ideales, la rosa y un mensaje para la tarjeta.", asesor: true });
      guardar();
      pintar();
      return;
    }

    cargando = true;
    send.disabled = true;
    pintar();

    var ctrl = new AbortController();
    var reloj = setTimeout(function () { ctrl.abort(); }, TIMEOUT);
    var mensajes = historial.map(function (m) { return { role: m.role, content: m.content }; });

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: mensajes }),
      signal: ctrl.signal
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        historial.push({
          role: "assistant",
          content: d.reply || "No tengo ese dato confirmado. Escríbenos por WhatsApp y te lo damos con precisión."
        });
      })
      .catch(function () {
        historial.push({
          role: "assistant",
          content: "No pude conectarme en este momento. Escríbenos por WhatsApp y te atendemos enseguida."
        });
      })
      .then(function () {
        clearTimeout(reloj);
        cargando = false;
        send.disabled = false;
        guardar();
        pintar();
      });
  }

  send.onclick = function () { enviar(); };
  input.onkeydown = function (e) { if (e.key === "Enter") enviar(); };

  /* ── Abrir / cerrar ────────────────────────────────────── */
  function esMovil() { return window.matchMedia("(max-width:520px)").matches; }

  function abrir() {
    if (abierto) return;
    abierto = true;
    ocultarInvita();
    panel.classList.add("abierto");
    if (esMovil()) {
      velo.classList.add("on");
      document.body.style.overflow = "hidden";
    }
    if (!historial.length) { historial.push({ role: "assistant", content: SALUDO }); guardar(); }
    pintar();
    requestAnimationFrame(function () { panel.classList.add("visible"); });
    setTimeout(function () { if (!esMovil()) input.focus(); }, 450);
  }

  function cerrar() {
    if (!abierto) return;
    abierto = false;
    panel.classList.remove("visible");
    velo.classList.remove("on");
    document.body.style.overflow = "";
    setTimeout(function () { panel.classList.remove("abierto"); }, 450);
    fab.focus();
  }

  fab.onclick = function () { abierto ? cerrar() : abrir(); };
  panel.querySelector("#aria-close").onclick = cerrar;
  velo.onclick = cerrar;
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && abierto) cerrar(); });
})();
